module.exports = __webpack_public_path__ + "static/media/icon_sentaku2_blue.05eae99c.svg";